
import QRCode from "react-qr-code"
import Button from "../Components/Button"
import { createRef } from "react"
import { twJoin } from "tailwind-merge"

function Invite() {

    const copyLink = createRef()
    const shareText = `You are being invited to my Encircled Personal Journey as a part of my Mentor Circle! I have joined the Encircled program, which will help me gather a Mentor Circle so that I can better Live out who God created me to be in Community? A Mentor Circle are the Intentional adults like parents, mentors, aunts and peers that are supportive of students! Will you create a Login as instructed so that you can see how you can journey with me into all that God has for me. \n\n${window.location.href}`;
    const copyText = createRef()

    const onCopy = () => {
        navigator.clipboard.writeText(window.location.href)
        copyLink.current.innerText = "Copied!"
        setTimeout(() => {
            copyLink.current.innerText = "Copy Link"
        }
        , 2000)
    }

    const onCopyText = () => {

        navigator.clipboard.writeText(shareText)
        copyText.current.innerText = "Copied!"
        setTimeout(() => {
            copyText.current.innerText = "Copy Sample Text"
        }
        , 2000)
    }

    const onEmail = () => {
        window.location.href = `mailto:?subject=Join My Mentor Circle&body=I would like to invite you to join my mentor circle. Click the link below to join: ${window.location.href}`
    }

    return <div>
        <h1 className="font-bold text-2xl text-center mb-6">Four Ways to Share</h1>
        <h2 className="font-bold text-lg mb-2">Share via Email</h2>
        <div className="mb-6">
            <Button onClick={onEmail}><i className="fa-solid fa-envelope mr-2"></i>Send email</Button>
        </div>

        <div className="mb-6">
            <div className="flex gap-4 items-center mb-4">
                <h2 className="font-bold text-lg">Share the Link</h2>
                <button className="text-white whitespace-nowrap px-3 py-2 rounded-lg uppercase font-bold bg-neutral-800 hover:bg-neutral-800/90 text-xs" onClick={onCopy}><i className="fa-solid fa-link mr-2"></i><span ref={copyLink}>Copy</span></button> 
            </div>
            <input type="text" className="w-full h-12 px-4 text-base rounded" value={window.location.href} />
        </div>

        <div className="mb-6">
            <div className="flex gap-4 items-center mb-4">
                <h2 className="font-bold text-lg">Send a Text</h2>
                <button className="text-white whitespace-nowrap px-3 py-2 rounded-lg uppercase font-bold bg-neutral-800 hover:bg-neutral-800/90 text-xs" onClick={onCopyText}><i className="fa-solid fa-mobile-screen-button mr-2"></i><span ref={copyText}>Copy</span></button>
            </div>
            <textarea className="w-full h-36 px-4 text-xs rounded">
                {shareText}
            </textarea>
        </div>
        <div>
        <h2 className="font-bold text-lg mb-2">Share via QR Code</h2>
        <div className=" uppercase pb-4 rounded-lg uppercase font-bold">
            <div className="h-48 w-48">
                    <QRCode
                        size={48}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={window.location.href}
                        viewBox={`0 0 256 256`}
                    />
                </div>
        </div>  
        </div>
    </div>
  }
  
  export default Invite
  